import { render, staticRenderFns } from "./ContentPropertySubdivision.vue?vue&type=template&id=f9b53724&lang=pug&"
import script from "./ContentPropertySubdivision.vue?vue&type=script&lang=ts&"
export * from "./ContentPropertySubdivision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports